import {generateInvoiceById,getInvoiceById,getInvoices,createInvoice,updateInvoice,removeInvoice} from '../api/invoice';

import {getErrors} from '../utils/tools';

export function getInvoiceByIdAction(id,invoices) {
  return(dispatch)=>{
    /* Vérifie is l'invoice existe dans le state */
    /*let exist = false
    for (var i in invoices) {
      if(parseInt(id, 10) === parseInt(invoices[i].id, 10)) {
        exist = true
        dispatch({
            type:"UPDATE_INVOICE",
            invoice:invoices[i]
        });
        return Promise.resolve("ok");
      }
    }*/

    //if (!exist){
      return this.loggedIn().then((res) => { // Vérifie l'authentification
        const token = localStorage.getItem("id_token")
        return getInvoiceById(token,id)
          .then(res => {
            dispatch({
                type:"UPDATE_INVOICE",
                invoice:res
            });
          })
          .catch((err)=>{
            let errors = getErrors(err)
            this.displaySnackbar("error", errors[0].message);
            throw err
          })
      })
    //}
  }
}

export function getInvoicesAction() {
  return(dispatch)=>{
    return this.loggedIn().then((res) => { // Vérifie l'authentification
      const token = localStorage.getItem("id_token")
      return getInvoices(token)
        .then(res => {
          dispatch({
              type:"UPDATE_INVOICES",
              invoices:res
          });
          return res;
        })
        .catch((err)=>{
          let errors = getErrors(err)
          this.displaySnackbar("error", errors[0].message);
          throw err
        })
    })
  }
}

/*
  Enregistre un nouvel invoice
*/
export function createInvoiceAction(data) {
  return(dispatch)=>{
    return this.loggedIn().then((res) => { // Vérifie l'authentification
      const token = localStorage.getItem("id_token")
      return createInvoice(token, data)
        .then(res => {
            this.displaySnackbar("success", "Facture enregistré");
            dispatch({
                type:"ADD_INVOICE",
                invoice:res
            }, () =>{return res});

        })
        .catch((err)=>{
          let errors = getErrors(err)
          this.displaySnackbar("error", errors[0].message);
          throw err
        })
    })
  }
}

/*
  Met à jour un invoice
*/
export function updateInvoiceAction(id, data) {
  return(dispatch)=>{
    return this.loggedIn().then((res) => { // Vérifie l'authentification
      const token = localStorage.getItem("id_token")
      return updateInvoice(token, id, data)
        .then(res => {
          dispatch({
              type:"UPDATE_INVOICE",
              invoice:res
          });
          this.displaySnackbar("success", "Facture modifié");
          return res
        })
        .catch((err)=>{
          let errors = getErrors(err)
          this.displaySnackbar("error", errors[0].message);
          throw err
        })
    })
  }
}

/*
  Supprimer un invoice
*/
export function removeInvoiceAction(id, data) {
  return(dispatch)=>{
    return this.loggedIn().then((res) => { // Vérifie l'authentification
      const token = localStorage.getItem("id_token")
      return removeInvoice(token, id)
        .then(res => {
          dispatch({
              type:"REMOVE_INVOICE",
              id:id
          });
          this.displaySnackbar("success", "Facture supprimé");
          return res
        })
        .catch((err)=>{
          let errors = getErrors(err)
          this.displaySnackbar("error", errors[0].message);
          throw err
        })
    })
  }
}

/*
  Générer une facture au format pdf
*/
export function generateInvoiceAction(id, filename) {
  return(dispatch)=>{
    return this.loggedIn().then((res) => { // Vérifie l'authentification
      const token = localStorage.getItem("id_token")
      return generateInvoiceById(token, id, filename)
        .then(res => {
          this.displaySnackbar("success", "Facture génerée");
          return res
        })
        .catch((err)=>{
          //let errors = getErrors(err)
          this.displaySnackbar("error", "La facture n'a pu être générée");
          throw err
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/invoice.js